import AccountUserAvatarSelector from '@/ui/components/accountUserAvatarSelector/AccountUserAvatarSelector';
import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';
import { TimelogsPermissions } from '@payaca/permissions/timelogs/timelogs.permissions';
import { FC } from 'react';
import { PermissionGuard } from '../../permissionGuard/PermissionGuard';
import { useListedTimelogsContext } from './listedTimelogsContext';

export const AssigneeFilter: FC = () => {
  const { input, setFilter, teamMemberPublicIds } = useListedTimelogsContext();

  const assigneeIds =
    input?.assignees?.filter((a) => a.type === 'USER').map((a) => a.id) || [];

  return (
    // Needs both timelog access and user-list access: the selector fetches the
    // account users internally, so a user without GET_USERS shouldn't see it
    // (matches the schedule dispatch filters). Nested guards = AND.
    <PermissionGuard
      renderIfHasPermissions={[TimelogsPermissions.GET_TIMELOGS]}
    >
      <PermissionGuard renderIfHasPermissions={[AccountsPermissions.GET_USERS]}>
        <AccountUserAvatarSelector
          selectedUserIds={assigneeIds}
          filterUserPublicIds={teamMemberPublicIds}
          onChange={(next) =>
            setFilter({
              // Empty selection clears the filter (undefined = everyone). An
              // empty *list* is reserved for "filter matches no one" (see the
              // team expansion in listedTimelogsContext).
              assignees: next.length
                ? next.map((id) => ({ id, type: 'USER' }))
                : undefined,
            })
          }
        />
      </PermissionGuard>
    </PermissionGuard>
  );
};
